<template>
<h1> import </h1>
  <form @submit.prevent="submit">
    <input type="file" @input="form.file = $event.target.files[0]">
    <button type="submit">Submit</button>
  </form>
</template>

<script setup>

import {useForm} from "@inertiajs/inertia-vue3";

const props = defineProps(['import_url']);

const form = useForm({
  file : null,
});

function submit(){
  console.log(props.import_url)
  form.post(props.import_url)
}
</script>

<style scoped>

</style>
